import React, { useEffect, useCallback, useRef } from "react";
import { Container, Table, Col, Button, Form } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchSimulationCGroOnly, simulationCGroAdded } from "../../Redux/simulationCReduce";
import Select from "react-select";
import NotificationAlert from "react-notification-alert";
import Swal from "sweetalert2";

function DetailSimulationCGro({ client, obj }) {
    const dispatch = useDispatch();
    const navigate = useHistory();
    const location = useParams();

    const [loading, setLoading] = React.useState(false);
    const [loader, setLoader] = React.useState(true);

    const [produitsData, setProduitsData] = React.useState([]);   // 🔵 MAIN STATE FOR PRODUCTS
    const [tete, setEntitieTete] = React.useState([]);
    const [date, setDate] = React.useState(null);
    const [typeCommande, setTypeCommande] = React.useState(null);
    const [typeProduit, setTypeProduit] = React.useState([]);
    const [optionsDate, setOptionsDate] = React.useState([]);

    const saveCalled = useRef(false);

    const id = location.id;
    const id_grossiste = location.id_grossiste;

    const notificationAlertRef = React.useRef(null);
    const notify = (place, msg, type) => {
        const options = {
            place,
            message: <div><div>{msg}</div></div>,
            type,
            icon: "nc-icon nc-bell-55",
            autoDismiss: 7,
        };
        notificationAlertRef.current.notificationAlert(options);
    };

    // 🟦 Update quantity
    const handleChangeQuantite = (index, value) => {
        const newData = [...produitsData];
        newData[index].quantite = Number(value) || 0;
        setProduitsData(newData);
    };

    // 🟦 Fetch data
    const getSimulationCGro = useCallback(async () => {
        try {
            const res = await dispatch(fetchSimulationCGroOnly({ id, id_grossiste }));
            const data = res?.payload?.data;

            if (!data || data.length === 0) {
                notify("tr", "Aucune donnée trouvée", "danger");
                navigate.push(client + "/commandeList");
                return;
            }

            setProduitsData(data);

            data.forEach(el => typeProduit.push(el.type_produit));

            // 🟦 Build date options
            let options = [{ value: null, label: "Autre" }];
            if (data[0].date1) options.push({ value: data[0].date1, label: data[0].date1 });
            if (data[0].date2) options.push({ value: data[0].date2, label: data[0].date2 });

            setOptionsDate(options);
            setTypeCommande(data[0].type);


            setLoader(false);
        } catch (err) {
            console.log(err);
            notify("tr", "Erreur de chargement", "danger");
            navigate.push(client + "/listSimulationCGro");
        }
    }, [client]);

    useEffect(() => {
        getSimulationCGro();
    }, [getSimulationCGro]);

    // 🟦 Submit
    async function submitForm() {
        if (!date) {
            notify("tr", "Date est obligatoire", "danger");
            return;
        }

        if (saveCalled.current) return;
        saveCalled.current = true;
        setLoading(true);

        // Vérifier si plusieurs types
        let divise = 0;
        const types = [...new Set(typeProduit)];

        let continuerSave = 0;
        const resultSwal = await Swal.fire({
            title: 'Voulez-vous continuer ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non',
        });

        if (resultSwal.isConfirmed) {
            continuerSave = 1;
        }


        console.log(produitsData)

        if (types.length > 1) {
            const result = await Swal.fire({
                title: "Division Commande",
                text: "La commande contient plusieurs types (AMM et AMC). Voulez-vous diviser la commande ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Oui, diviser",
                cancelButtonText: "Non",
            });
            if (result.isConfirmed) divise = 1;
        }
        if (continuerSave == 1) {
            dispatch(
                simulationCGroAdded({
                    id_site: client == "/medis" ? 2 : 3,
                    divise,
                    id,
                    date: date.value,
                    type_commande: typeCommande,
                    id_grossiste,
                    client,
                    produits: produitsData,
                })
            ).then((result) => {
                if (result.payload.success === true) {
                    notify("tr", "Validé avec succès", "success");
                    setTimeout(() => listepp(), 800);
                } else {
                    saveCalled.current = false;
                    setLoading(false);
                    notify("tr", "Problème de connexion", "danger");
                }
            });
        } else {
            saveCalled.current = false;
            setLoading(false);
        }
    }

    function listepp() {
        navigate.push(client + "/listSimulationCGro");
    }

    return (
        <Container fluid>
            <NotificationAlert ref={notificationAlertRef} />

            {obj.user.id_role != 6 && (
                <Col md="12">
                    <Button
                        id="saveBL"
                        className="btn-wd btn-outline mr-1 float-left"
                        variant="info"
                        onClick={listepp}
                    >
                        <i className="fas fa-list"></i> Retour à la liste
                    </Button>
                </Col>
            )}

            {loader ? (
                <div className="loader-container">
                    <div className="loader"></div>
                </div>
            ) : (
                <div>
                    <Table bordered hover style={{ textAlign: "center" }}>
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{typeCommande}</td>
                                <td>
                                    <Col md="6">
                                        <label>Date *</label>
                                        <Select
                                            value={date}
                                            onChange={(selected) => setDate(selected)}
                                            options={optionsDate}
                                            placeholder="Date"
                                            isClearable
                                        />
                                    </Col>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                    <hr style={{ borderTop: "4px solid black" }} />

                    {/* 🟦 PRODUCTS TABLE */}
                    <Table bordered hover>
                        <thead className="entete_detail">
                            <tr>
                                <th>Code article</th>
                                <th>Produit</th>
                                <th>Quantité</th>
                            </tr>
                        </thead>
                        <tbody>
                            {produitsData.map((element, key) => (
                                <tr key={key}>
                                    <td>{element.code_article}</td>
                                    <td>{element.produit}</td>
                                    <td>
                                        <Form.Control
                                            type="number"
                                            value={element.quantite}
                                            onChange={(e) => handleChangeQuantite(key, e.target.value)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    <br /><br />

                    {loading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Enregistrement en cours...
                        </>
                    ) : (
                        <Button variant="info" className="mt-4" onClick={submitForm}>
                            Enregistrer et Valider
                        </Button>
                    )}
                </div>
            )}
        </Container>
    );
}

export default DetailSimulationCGro;
